import clsx from "clsx";
import React, { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";

import Button from "~/shared/ui/Fields/Button";
import Checkbox from "~/shared/ui/Fields/Checkbox";
import Modal from "~/shared/ui/Fields/Modal";
import { useNotify } from "~/shared/hooks/useNotify";

import { getDataStaffReportPositions } from "./GetDataStaffRequests/getDataStaffReportPositions";

import s from "./Staff.less";

export default function StaffModal({
  handleModal,
  modal,
  queryData,
  urlParams,
}) {
  const [data, setData] = useState([]);
  const [queryEnabled, setQueryEnabled] = useState(false);
  const [url, setUrl] = useState("");
  const { notifyReport } = useNotify();
  const { t } = useTranslation();
  const params = new URLSearchParams();

  const {
    data: positions,
    error,
    isLoading,
  } = useQuery({
    queryKey: ["getStaffReportPositions", url],
    queryFn: () => getDataStaffReportPositions(url),
    enabled: queryEnabled,
    staleTime: Infinity,
  });

  const check = (prop) => {
    data
      .filter((item) => item.check)
      .forEach((i) =>
        params.append("expectationsIds[]", i.expectation.instanceId)
      );
    setUrl(() => {
      return urlParams + "&" + params.toString();
    });
    setQueryEnabled(true);
  };

  useEffect(() => {
    if (queryData && modal) {
      setData(() =>
        queryData?.lines.map((item) => {
          return { check: false, ...item };
        })
      );
    }
  }, [queryData, modal]);

  const checkAll = useCallback(
    (prop) => {
      setData((data) =>
        data.map((item) => {
          return { ...item, check: prop };
        })
      );
    },
    [data]
  );

  const checkItem = (index, e) => {
    setData((data) => {
      return data.map((item, i) => {
        if (i === index) {
          return { ...item, check: e };
        } else {
          return item;
        }
      });
    });
  };

  useEffect(() => {
    if (positions) {
      notifyReport(positions.fileHash);
    }
  }, [positions]);

  return (
    <Modal actionClose={handleModal} isOpen={modal}>
      <div style={{ overflowY: "auto", height: "600px" }}>
        <div style={{ display: "flex", alignItems: "baseline", scale: "0.8" }}>
          <span>
            <Checkbox onCheck={checkAll} />
          </span>
          <span>{"Выбрать всех"}</span>
        </div>
        {data &&
          modal &&
          data.map((item, index) => {
            return (
              <div
                key={item.expectation.instanceId}
                style={{
                  display: "flex",
                  alignItems: "center",
                  scale: "0.8",
                }}
              >
                <div>
                  <Checkbox
                    name={item.expectation.instanceId}
                    checked={item.check}
                    onCheck={(e) => checkItem(index, e)}
                  />
                </div>
                <div>
                  {item.expectation.positions.map((i) => {
                    return (
                      <div key={i.code}>
                        {i.code} / {i.name}
                      </div>
                    );
                  })}
                </div>
              </div>
            );
          })}
        <div
          style={{ display: "flex", justifyContent: "end", marginTop: "10px" }}
        >
          <Button
            txtBtn={t("q.save_excel")}
            small
            green
            customClassName={clsx(s.btn_center, s.correct_margin)}
            onClick={check}
          />
        </div>
      </div>
    </Modal>
  );
}
